document.addEventListener("DOMContentLoaded", function () {

  //Toggle Main Menu
  const menuBtn = document.querySelector(".Header__Icon.Icon-Wrapper");

  if (menuBtn) {
    menuBtn.addEventListener("click", function () {
      document.body.classList.toggle("menu-openning");
    });
  }

  //Open Mega Menu
  function bindMobileMega() {

    const isMobile = window.innerWidth < 1141;

    document.querySelectorAll(".item-label.item-plus").forEach(function (el) {
      el.addEventListener("click", function (e) {
        if (!isMobile) return;
        e.preventDefault();
        const parentLi = el.closest(".HorizontalList__Item");
        if (parentLi) {
          parentLi.classList.toggle("megamenu-expanded");
        }
      });
    });

    document.querySelectorAll(".back-link-mobile").forEach(function (el) {
      el.addEventListener("click", function (e) {
        e.preventDefault();
        const parentLi = el.closest(".HorizontalList__Item");
        if (parentLi) {
          parentLi.classList.remove("megamenu-expanded");
        }
      });
    });
  }

  bindMobileMega();
  window.addEventListener("resize", bindMobileMega);
});
 